export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const AUTO_HIDDEN = 2000
 